import { FileQuestion } from "lucide-react";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import type { NotFoundStateProps } from "../types";

const DEFAULT_TITLE = "Ressource introuvable";
const DEFAULT_DESCRIPTION = "La ressource demandée n'existe pas ou a été supprimée.";

export const NotFoundState = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, className }: NotFoundStateProps) => {
  return (
    <div className={cn("flex min-h-[50vh] w-full flex-col items-center justify-center gap-3 text-center", className)}>
      <FileQuestion className="size-10 text-muted-foreground" />
      <div className="space-y-1">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
};
